import { createStateHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useTraineesState = createStateHook(
  AppStoreProvider,
  state => state.pages.trainees
)
